import { autoinject } from 'aurelia-framework';
import { IForm, State } from 'app/shared/lib/essette-site';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { AssistanceService } from 'app/shared/services/assistance-service';
import { ApiError } from 'app/shared/lib/api/api-types';
import { Toaster } from 'app/shared/lib/toaster';
import { PasswordService } from 'app/core/services/password-service';
import { I18N } from 'aurelia-i18n';

@autoinject
export class ChangePassword implements IForm {

    protected loginName: string = '';
    protected currentPassword: string = '';
    protected newPassword: string = '';
    protected confirmPassword: string = '';

    public readonly state: State = new State();

    constructor(
        private readonly env: EnvironmentService,
        private readonly toaster: Toaster,
        protected readonly passwordService: PasswordService,
        private readonly assistanceService: AssistanceService,
        private readonly i18n: I18N,) {
    }

    protected bind(): void {
        this.clear();
    }

    public clear(): void {
        this.loginName = this.env.user.loginName || '';
        this.currentPassword = this.newPassword = this.confirmPassword = '';
    }

    ////****************** IForm ****************************************************////
    public hasChanges(): boolean {
        return false;
    }

    public async submit(): Promise<boolean> {
        if(!this.loginName || !this.currentPassword || !this.newPassword) {
            return false;
        }

        try {
            this.state.beginSave();

            const response = await this.assistanceService.changePassword(this.loginName, this.currentPassword, this.newPassword);
            return response.isSuccessful;
        }
        catch(e) {
            if(e instanceof ApiError) {
                if(e.hasError('password.previouslyUsed')) {
                    this.toaster.error().message(this.i18n.tr('core:local.changePassword.cannotRepeatPassword')).show();
                    return false;
                }
                else if(e.hasError('password.locked')) {
                    this.toaster.error().message(this.i18n.tr('core:local.changePassword.passwordForAccountCannotBeChanged')).show();
                    return false;
                }
            }
            this.toaster.error().message(this.i18n.tr('core:local.changePassword.unableToChangePassword')).show();
            return false;
        }
        finally {
            this.state.endSave();
        }
    }

    public reset?(): void {
        this.clear();
    }

    protected passwordsMatch(password1: string, password2: string): boolean {
        if(password1) { return password1 === password2; }
        return !password2;

    }

}
